import { render, staticRenderFns } from "./report_doc_delete.vue?vue&type=template&id=1798476c&"
import script from "./report_doc_delete.vue?vue&type=script&lang=js&"
export * from "./report_doc_delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1798476c')) {
      api.createRecord('1798476c', component.options)
    } else {
      api.reload('1798476c', component.options)
    }
    module.hot.accept("./report_doc_delete.vue?vue&type=template&id=1798476c&", function () {
      api.rerender('1798476c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_report/doc/report_doc_delete.vue"
export default component.exports